import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.set.constructor.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.iterator.js';
import { __assign, __spreadArray } from '../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';

function attachControlToProps(children, triggers, control) {
  if (triggers === void 0) {
    triggers = [];
  }
  var props = __assign(__assign({}, children.props), control);
  var triggersSet = new Set(triggers);
  triggersSet.forEach(function (eventName) {
    props[eventName] = function () {
      var _a, _b, _c;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      (_a = control[eventName]) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([control], args, false));
      (_c = (_b = children.props)[eventName]) === null || _c === void 0 ? void 0 : _c.call.apply(_c, __spreadArray([_b], args, false));
    };
  });
  return props;
}

export { attachControlToProps };
